import { autoinject, transient, BindingEngine, computedFrom } from "aurelia-framework";
import {
    NotificationClientService
} from "../../../../../services/basics/notification-client.service";
import { Router } from "aurelia-router";
import { RightShipQiRouterConstants } from "../../../../../configuration/rightshipqi-router.constants";
import { StepModel } from "../../../../../models/basics/basics.models";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { Guid } from "../../../../../utilities/guid";
import { RightShipInspectionModel, RightShipInspectionType, RightShipInspectionInvoiceModel, RightShipInspectionStatusEnum, CargillInspectionDetailModel, RightShipInspectionSourceEnum } from "../../../../../models/rightship-inspections/rightship-inspections.models";
import { RightShipInspectionsService } from "../../../../../services/rightship-inspections/rightship-inspections.service";
import { I18N } from "aurelia-i18n";
import { UserClientService } from "../../../../../services/authentication/user-client.service";
import { ValidationsClientService } from "../../../../../services/validations/validations-client.service";
import { UnitOfWorkItem } from "../../../../../utilities/unit-of-work-observer";
import { BaseValidationResponse } from "../../../../../models/validations/validations.models";
import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { CacheClientService } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { TasksConstants, TasksStepsEnum } from "../../../../../models/tasks/task.model";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { ValidationTypeEnum, ValidationActivation } from "../../../../../client-validation-system/validations.models";
import { EntityValidationsService, ClientSideValidator } from "../../../../../client-validation-system/validations-service";
import { Reflection } from "../../../../../utilities/reflection";
import { BaseOfficeTimeBaseEntity } from "../../common-steps/base-office-time";
import { Operation } from "../../../../../client-validation-system/base-validations/compare-validation";
import { GenesisRouterConstants } from "../../../../../configuration/router.constants";
import { BindingSignaler } from "aurelia-templating-resources";
import { VesselDetailsTab } from "./tabs/vessel-details-tab";
import { PortAndOperationalDetailsTab } from "./tabs/port-and-operational-details-tab";
import { ShipManagerDetailsTab } from "./tabs/ship-manager-details-tab";
import { AgentDetailsTab } from "./tabs/agent-details-tab";
import { InvoiceTransmissionDetailsTab } from "./tabs/invoice-transmission-details-tab";
import { DeclarationTab } from "./tabs/decleration-tab";
import { RiskFactorTab } from "./tabs/risk-factor-tab";
import * as Enumerable from 'linq';
import { UrlHelper } from "../../../../../helpers/url-helper";
import { Messages } from "../../../../../configuration/event-messages.constants";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { MessageCentreIntroTab } from "./tabs/message-centre-intro-tab";

class InspectionTabs {
    title: string;
    vm: any;
    path: string;
    element?: Element;
    isVisible: (() => boolean);
}

@autoinject
@transient()
export class AddRightShipInspection extends BaseOfficeTimeBaseEntity<RightShipInspectionModel> {

    private _tabs: InspectionTabs[];
    public disableButtons: boolean;
    currentTabIndex: number = 0;
    inspectionTypeId: number;
    isAuthenticated: boolean;
    hasPendingInspection: boolean;
    vesselHasRequiredRightShipInspection: boolean;
    rightShipInspectionRequestSubmitted: boolean = false;
    showActions: boolean = true;
    validator: ClientSideValidator;
    validatorInvoice: ClientSideValidator;
    validatiorInvoiceEmails: ClientSideValidator;
    validatorShipManagerEmails: ClientSideValidator;
    validatorTerms: ClientSideValidator;
    validatorCargilDetails: ClientSideValidator;
    validatorManualPort: ClientSideValidator;
    validatorHybrid: ClientSideValidator;
    private _eventAggregatorSubscriptions: Subscription[] = [];
    public isSanctioned: boolean;
    public isRestricted: boolean;
    public beneficialOwnerIsNullOrUnkown: boolean;
    private _messageCenterOn: boolean = false;
    private _isCompanyRestricted: boolean;

    @computedFrom("_tabs")
    get tabs() {
        return this._tabs.filter(x => x.isVisible())
    }

    getVisibleIndex(index) {
        return this.tabs[index] ? this.tabs.indexOf(this.tabs[index]) : null;
    }

    hasError(tab: InspectionTabs) {
        return tab.element && $(tab.element).find(".error-validation").length > 0;
    }

    setCurrentTabIndex(index: number) {
        this.currentTabIndex = index;
        this.bindingSignaler.signal("rs_inspection_tab_change");

        this.scrollToTop();
    }

    handleUpdateCompleted(response: any, isNew: boolean) {
        if (this.isEdit) {
            super.handleUpdateCompleted(response, isNew);
            this.router.navigateBack();
        } else {
            this.rightShipInspectionRequestSubmitted = true;
            this.scrollToTop();
        }
    }

    scrollToTop() {
        const scrollElement = document.getElementsByClassName('add-rightship-inspection-scroller').item(0) as HTMLDivElement;
        setTimeout(() => {
            if (scrollElement) {
                scrollElement.scrollTop = 0;
            }
        });
    }

    canAccessRightshipInspections: boolean;
    canAccessCargillInspections: boolean;
    canAccessTankerInspections: boolean;
    canCreateCargillInspection: boolean;

    @computedFrom('inspectionTypeId')
    get isDry() {
        return this.inspectionTypeId == RightShipInspectionType.RightShipInspection;
    }

    @computedFrom('inspectionTypeId')
    get canViewInspection() {
        switch (this.inspectionTypeId) {
            case RightShipInspectionType.CargillSurvey:
                return this.canAccessCargillInspections;
            case RightShipInspectionType.RightShipInspection:
                return this.canAccessRightshipInspections;
            case RightShipInspectionType.TankerInspection:
                return this.canAccessTankerInspections;
            default: false;
        }
    }


    public submit = (item: RightShipInspectionModel, dontHandleOnComplete: boolean = false, skipValidation: boolean = false, returnNullWhenSaveError: boolean = false): Promise<() => void> => {
        return new Promise<() => void>((resolve, reject) => {
            this.save(item, dontHandleOnComplete, skipValidation, returnNullWhenSaveError).then(resolve, reject);
        });
    };

    public next = (): Promise<() => void> => {
        return new Promise<() => void>((resolve) => {
            const tab = this.tabs.filter(x => x.isVisible()).filter(x => this.tabs.indexOf(x) > this.currentTabIndex)[0];
            this.setCurrentTabIndex(this.tabs.indexOf(tab));
            resolve(() => { });
        });
    };

    @computedFrom('inspectionTypeId')
    get isCargill() {
        return this.inspectionTypeId == RightShipInspectionType.CargillSurvey;
    }

    @computedFrom('isEdit', 'inspectionTypeId')
    get showTermsAndConditions(): boolean {
        return this.isDry && !this.isEdit;
    }

    @computedFrom('inspectionTypeId')
    get inspectionType() {
        switch (this.inspectionTypeId) {
            case RightShipInspectionType.RightShipInspection: return "RightShip";
            case RightShipInspectionType.CargillSurvey: return "Cargill";
            case RightShipInspectionType.TankerInspection: return "Tanker";
        }
        return "";
    }

    @computedFrom(Reflection.getPropertyPath<AddRightShipInspection>(v => v.router.currentInstruction))
    public get previousInstructionTitle(): string {
        const prevInstruction = this.router.currentInstruction.previousInstruction;
        if (prevInstruction && prevInstruction.config.name == RightShipQiRouterConstants.RouteNames.RightShipInspection) {
            return this.inspectionType + " Inspection";
        }
        return prevInstruction
            ? prevInstruction.config.title
            : this.i18N.tr('back-text');
    }

    @computedFrom('inspectionTypeId')
    public get rightshipEmail(): string {
        switch (this.inspectionTypeId) {
            case RightShipInspectionType.RightShipInspection: return "dryinspections@rightship.com";
            case RightShipInspectionType.CargillSurvey: return "tankerinspections@rightship.com";
            case RightShipInspectionType.TankerInspection: return "tankerinspections@rightship.com";
        }
        return "";
    }

    constructor(private rightShipInspectionService: RightShipInspectionsService,
        router: Router, private vesselDetails: VesselDetailsTab, private portAndOperationalDetails: PortAndOperationalDetailsTab,
        private manageVesselService: ManageVesselService, private shipManagerDetailsTab: ShipManagerDetailsTab,
        bindingEngine: BindingEngine, private agentDetailsTab: AgentDetailsTab, private riskFactorTab: RiskFactorTab, private declarationTab: DeclarationTab,
        i18N: I18N, private invoiceTransmissionDetailsTab: InvoiceTransmissionDetailsTab, private messageCentreIntroTab: MessageCentreIntroTab,
        notificationService: NotificationClientService,
        userClientService: UserClientService,
        private userClaimsService: UserClaimsService,
        eventAggregator: EventAggregator,
        validationsClientService: ValidationsClientService,
        private cacheClient: CacheClientService,
        private entityValidationsService: EntityValidationsService,
        private bindingSignaler: BindingSignaler,
        private configService: ConfigService) {
        super(router, bindingEngine, i18N, notificationService, eventAggregator, validationsClientService);
        this.isAuthenticated = userClientService.currentUser && userClientService.currentUser.id > 0;
        this.canAccessRightshipInspections = this.userClaimsService.hasPermission(Claims.CanAccessRightShipInspections);
        this.canAccessCargillInspections = this.userClaimsService.hasPermission(Claims.CanAccessCargillInspections);
        this.canAccessTankerInspections = this.userClaimsService.hasPermission(Claims.CanAccessWetInspections);
        this.canCreateCargillInspection = this.userClaimsService.hasPermission(Claims.CanCreateCargillInspection);
        this._messageCenterOn = this.configService.config.settings.messageCenterOn;
        this.declarationTab.navigateBack = this.navigateBack;
        this._tabs = [
            { title: "Vessel Details", vm: this.vesselDetails, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/vessel-details-tab', isVisible: () => true },
            { title: "Port and Operational Details", vm: this.portAndOperationalDetails, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/port-and-operational-details-tab', isVisible: () => true },
            { title: "Ship Manager Details", vm: this.shipManagerDetailsTab, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/ship-manager-details-tab', isVisible: () => true },
            { title: "Risk Factors", vm: this.riskFactorTab, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/risk-factor-tab', isVisible: () => this.isCargill },
            { title: this.isCargill ? "Inspector appointment" : "Agent Details", vm: this.agentDetailsTab, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/agent-details-tab', isVisible: () => !this.isCargill || this.isEdit },
            { title: "Invoice Transmission Details", vm: this.invoiceTransmissionDetailsTab, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/invoice-transmission-details-tab', isVisible: () => !this.isCargill },
            { title: "RightShip Message Centre", vm: this.messageCentreIntroTab, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/message-centre-intro-tab', isVisible: () => this._messageCenterOn && !this.isCargill},
            { title: "Declaration", vm: this.declarationTab, path: 'views/pages/modules/rightship-inspection/add-rightship-inspection/tabs/decleration-tab', isVisible: () => !this.isWet || this.showTermsAndConditions }
        ];
    }

    attached() {
        const subscription = this.eventAggregator.subscribe(Messages.InspectedVesselChanged, (item) => {
            this.disableButtons = item.isDisabled;
        });
        this._eventAggregatorSubscriptions.push(subscription);
    }

    detached() {
        this._eventAggregatorSubscriptions?.forEach(subscription => {
            subscription.dispose();
        });
        this._eventAggregatorSubscriptions = [];
    }

    private setValidator() {
        const rules = [{
            errorMessage: "Vessel is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.vesselId),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Correspondence Email is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.correspondenceEmail),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Correspondence Email is not in correct format",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.correspondenceEmail),
            validationType: ValidationTypeEnum.Email
        }, {
            errorMessage: "Cargo Operation is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.cargoOperationId),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Country is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.countryId),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Estimated Date of Arrival is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.estimatedArrivalDate),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Reason for inspection is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.reasonForInspectionId),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Technical Manager Contact Number is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.technicalManagerContactNumberWithoutCode),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Technical Manager Email is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.technicalManagerEmail),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Technical Manager Email is not in correct format",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.technicalManagerEmail),
            validationType: ValidationTypeEnum.Email
        }, {
            errorMessage: "Technical Manager Name is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.technicalManagerName),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Technical Management Company is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.technicalManagmentCompany),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Vessel Owner Name is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.vesselOwnerName),
            validationType: ValidationTypeEnum.Required
        }];

        const agentRules = [{
            errorMessage: "Agent Email is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agentEmail),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Agent Email is not in correct format",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agentEmail),
            validationType: ValidationTypeEnum.Email
        }, {
            errorMessage: "Agent Name is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agentName),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Agent Office Number is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agentOfficeNumberWithoutCode),
            validationType: ValidationTypeEnum.Required
        }];
        if (this.inspectionTypeId != RightShipInspectionType.CargillSurvey)
            rules.push(...agentRules);

        const vesselDetailsRules = [
            {
                errorMessage: "Master's email is not in correct format",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.captainEmail),
                validationType: ValidationTypeEnum.Email
            },
            {
                errorMessage: "Vessel type is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.rightShipInspectionVesselTypeId),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is self unloading is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isSelfUnloadingVessel),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is using LNG is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isUsingLngFuel),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is equipped with gantry cranes is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isEquippedWithGantryCranes),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Has ice class notation is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.hasIceClassNotation),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is gearless is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isGearlessVessel),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is ro-ro ship is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isRoRoShip),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is timber carrier is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isTimberCarrier),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is carrying grain cargo and has been fumigated in past 12 months is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isCarryingGrainCargoAndHasBeenFumigatedInThePast12Months),
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Is the vessel involved in STS operations or planning to be involved in STS operations is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isVesselInvolvedInSts),
                validationType: ValidationTypeEnum.Required
            }
        ];

        if (this.inspectionTypeId == RightShipInspectionType.RightShipInspection)
            rules.push(...vesselDetailsRules);

        const rulesLocal = [];
        rulesLocal.push({
            errorMessage: "Country Code is required",
            parameters: null, property: "technicalManagerCountryCode",
            validationType: ValidationTypeEnum.Required
        });
        rulesLocal.push({
            errorMessage: "Country Code is required",
            parameters: null, property: "agentOfficeCountryCode",
            validationType: ValidationTypeEnum.Required
        });
        rulesLocal.push({
            errorMessage: "Country Code is required",
            parameters: null, property: "phoneCountryCode",
            validationType: ValidationTypeEnum.Required
        });
        rules.push({
            errorMessage: "Port is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.portId),
            validationType: ValidationTypeEnum.Required
        });

        if (this.isWet) {
            rules.push({
                errorMessage: "Berth is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.berth),
                validationType: ValidationTypeEnum.Required
            });
        }

        if (!this.isCargill) {
            rules.push({
                errorMessage: "Requested date of inspection is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.requestedDateOfInspection),
                validationType: ValidationTypeEnum.Required
            });

            if (this.item && this.item.estimatedArrivalDate && typeof (this.item.estimatedArrivalDate) == "string") {
                this.item.estimatedArrivalDate = new Date(this.item.estimatedArrivalDate);
            }
            if (this.item && this.item.requestedDateOfInspection && typeof (this.item.requestedDateOfInspection) == "string") {
                this.item.requestedDateOfInspection = new Date(this.item.requestedDateOfInspection);
            }
            if (!this.isEdit) {
                rules.push({
                    errorMessage: "Estimated Arrival Date cannot be set in the past",
                    parameters: {
                        property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.estimatedArrivalDate),
                        operation: Operation.GreaterThanOrEqual,
                        value: this.portAndOperationalDetails.estArrivalMinDate()
                    }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.estimatedArrivalDate),
                    validationType: ValidationTypeEnum.Compare
                });
            }
            rules.push({
                errorMessage: "Requested date of inspection cannot be set before 'Estimated Arrival Date'",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.requestedDateOfInspection),
                    operation: Operation.GreaterThanOrEqual,
                    otherProperty: Reflection.getPropertyName<RightShipInspectionModel>(x => x.estimatedArrivalDate)
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.requestedDateOfInspection),
                validationType: ValidationTypeEnum.Compare
            });
            rules.push({
                errorMessage: "Requested date of inspection cannot be set outside the time frame during which the vessel is at berth",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.requestedDateOfInspection),
                    operation: Operation.LessThanOrEqual,
                    value: this.portAndOperationalDetails.maxRequestDate
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.requestedDateOfInspection),
                validationType: ValidationTypeEnum.Compare
            });
            rules.push({
                errorMessage: "Length of time at berth is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.lengthOfTimeAtBerth),
                validationType: ValidationTypeEnum.Required
            });
        } else {
            rules.push({
                errorMessage: "Date of inspection is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.actualDateOfInspection),
                validationType: ValidationTypeEnum.Required
            });
        }

        const probabilityAndSeverityRuleHolder = {
            activation: ValidationActivation.Always,
            entityName: "Request RightShip Inspection Probability and severity",
            isCollection: false,
            nestedRulesHolder: [],
            rules: []
        };

        if (this.isCargill) {
            probabilityAndSeverityRuleHolder.rules.push(
                {
                    errorMessage: "Certification and documentation probability is required",
                    parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.certificationAndDocumentationProbability),
                    validationType: ValidationTypeEnum.Required
                }, {
                errorMessage: "Certification and documentation severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.certificationAndDocumentationSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Crew management probability is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.crewManagementProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Crew management severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.crewManagementSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Navigation probability is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.navigationProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Navigation severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.navigationSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Safety management probability is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.safetyManagementProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Safety management severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.safetyManagementSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Pollution management probability is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.pollutionManagementProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Pollution management severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.pollutionManagementSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Machinery spaces probability is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.machinerySpacesProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Machinery spaces severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.machinerySpacesSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Hull and deck items probability is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.hullAndDeckItemsProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Hull and deck items severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.hullAndDeckItemsSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Cargo and ballast systems probability severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.cargoAndBallastSystemsProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Cargo and ballast systems severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.cargoAndBallastSystemsSeverity),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Accommodation probability is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.accommodationProbability),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Accommodation severity is required",
                parameters: null, property: Reflection.getPropertyName<CargillInspectionDetailModel>(x => x.accommodationSeverity),
                validationType: ValidationTypeEnum.Required
            });
        }

        if (this.showTermsAndConditions) {
            rules.push({
                errorMessage: "Must agree to Safety Score clause",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agreeToSafetyScoreClause),
                    operation: Operation.Equal,
                    value: true
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agreeToSafetyScoreClause),
                validationType: ValidationTypeEnum.Compare
            });
            rules.push({
                errorMessage: "Must agree with RightShip's commitment to anti-bribery and anti-corruption laws",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.antiBriberyAndCorruptionPolicy),
                    operation: Operation.Equal,
                    value: true
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.antiBriberyAndCorruptionPolicy),
                validationType: ValidationTypeEnum.Compare
            });
            rules.push({
                errorMessage: "Must agree that vessel owner was informed",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isVesselOwnerInformedAndAgreed),
                    operation: Operation.Equal,
                    value: true
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.isVesselOwnerInformedAndAgreed),
                validationType: ValidationTypeEnum.Compare
            });
            rules.push({
                errorMessage: "Must agree that no letter of indemnity will be signed",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.noLetterOfIndemnityWillBeSigned),
                    operation: Operation.Equal,
                    value: true
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.noLetterOfIndemnityWillBeSigned),
                validationType: ValidationTypeEnum.Compare
            });

            rules.push({
                errorMessage: "Must agree to Both Owner And Manager Promptly Report",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.bothOwnerAndManagerPromptlyReport),
                    operation: Operation.Equal,
                    value: true
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.bothOwnerAndManagerPromptlyReport),
                validationType: ValidationTypeEnum.Compare
            });

            rules.push({
                errorMessage: "Must agree to Terms and Conditions",
                parameters: {
                    property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agreeToTermsAndConditions),
                    operation: Operation.Equal,
                    value: true
                }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.agreeToTermsAndConditions),
                validationType: ValidationTypeEnum.Compare
            });

            if(this._messageCenterOn) {
                rules.push({
                    errorMessage: "Must agree you have watched the video for Message Centre",
                    parameters: {
                        property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.ackWatchedMessageCentreVideo),
                        operation: Operation.Equal,
                        value: true
                    }, property: Reflection.getPropertyName<RightShipInspectionModel>(x => x.ackWatchedMessageCentreVideo),
                    validationType: ValidationTypeEnum.Compare
                });
            }

        }

        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Request RightShip Inspection",
            isCollection: false,
            nestedRulesHolder: [],
            rules: rules
        };

        const rulesInvoice = [{
            errorMessage: "Contact Name is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.contactName),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Company Name is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.companyName),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Address is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.address),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "City is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.city),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "State is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.state),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Country is required",
            parameters: `${Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.country)}:null`, //when country is null, since don't want to trigger validation when legacy country has value
            property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.countryId),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Postcode is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.postCode),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Phone number is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.phoneNumberWithoutCode),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Email is required",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.email),
            validationType: ValidationTypeEnum.Required
        }, {
            errorMessage: "Email is not in correct format",
            parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.email),
            validationType: ValidationTypeEnum.Email
        }];

        if (this.item && this.item.invoices && this.item.invoices[0] && this.item.invoices[0].invoiceReceivedDate && typeof (this.item.invoices[0].invoiceReceivedDate) == "string") {
            this.item.invoices[0].invoiceReceivedDate = new Date(this.item.invoices[0].invoiceReceivedDate);
        }

        rulesInvoice.push({
            errorMessage: "Invoice Received Date cannot be a future date",
            parameters: <any>{
                property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.invoiceReceivedDate),
                operation: Operation.LessThanOrEqual,
                value: this.today()
            }, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.invoiceReceivedDate),
            validationType: ValidationTypeEnum.Compare
        }, {
            errorMessage: "Post Code maximum length is 20 characters",
            parameters: JSON.stringify({ length: 20 }),
            property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.postCode),
            validationType: ValidationTypeEnum.MaxLength
        });

        const rulesHolderInvoiceEmails = {
            activation: ValidationActivation.Always,
            entityName: "Invoice Emails",
            isCollection: true,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Email is required",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.email),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "Email is not in correct format",
                parameters: null, property: Reflection.getPropertyName<RightShipInspectionInvoiceModel>(x => x.email),
                validationType: ValidationTypeEnum.Email
            }]
        };

        const rulesHolderShipManagerEmails = {
            activation: ValidationActivation.Always,
            entityName: "Ship Manager Emails",
            isCollection: true,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Email is not in correct format",
                parameters: null, property: "email",
                validationType: ValidationTypeEnum.Email
            }]
        }

        const rulesHolderInvoice = {
            activation: ValidationActivation.Always,
            entityName: "Request RightShip Inspection Invoice",
            isCollection: false,
            nestedRulesHolder: [],
            rules: rulesInvoice
        };

        const rulesHolderLocal = {
            activation: ValidationActivation.Always,
            entityName: "Request RightShip Inspection",
            isCollection: false,
            nestedRulesHolder: [],
            rules: rulesLocal
        }

        const hyridRules = [
            {
                errorMessage: "Inspection type is required",
                parameters: null, property: Reflection.getPropertyName<PortAndOperationalDetailsTab>(x => x.isHybrid),
                validationType: ValidationTypeEnum.Required
            },
        ];

        const hybridrulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Port And Operational Details Tab",
            isCollection: false,
            nestedRulesHolder: [],
            rules: hyridRules
        }

        this.validator = this.entityValidationsService.getValidator(this.item, rulesHolder);

        if (!this.isCargill) {
            this.validatorInvoice = this.entityValidationsService.getValidator(this.item.invoices[0], rulesHolderInvoice);
        }
        this.validatiorInvoiceEmails = this.entityValidationsService.getValidator(this.invoiceTransmissionDetailsTab.invoiceEmails, rulesHolderInvoiceEmails);
        this.validatorShipManagerEmails = this.entityValidationsService.getValidator(this.shipManagerDetailsTab.additionalEmailsToNotify, rulesHolderShipManagerEmails)
        this.validatorCargilDetails = this.entityValidationsService.getValidator(this.item.cargillInspectionDetails, probabilityAndSeverityRuleHolder);
        this.validatorManualPort = this.entityValidationsService.getValidator(this, rulesHolderLocal);
        this.validatorHybrid = this.entityValidationsService.getValidator(this.portAndOperationalDetails, hybridrulesHolder);
    }

    today() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    }

    navigateBack = () => {
        const tabs = this.tabs.filter(x => this.tabs.indexOf(x) < this.currentTabIndex);
        const tab = tabs[tabs.length - 1];
        this.setCurrentTabIndex(this.tabs.indexOf(tab));
    }

    cancel() {
        let goBackCount: number = this.router && this.router.history && this.router.history.getState("skipPreviousRoutes") ?
            this.router.history.getState("skipPreviousRoutes") : 0;
        goBackCount++;
        this.cacheClient.put(TasksConstants.TabsCacheKey, TasksStepsEnum.INSP).then(() => {
            if ((<any>this.router.history).history.length == 1 && this.item.vesselId)
                this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.VesselDetails, { id: this.item.vesselId }, { replace: true })
            else
                this.router.history.go(-goBackCount);
        })
            .catch(() => {
                this.router.history.go(-goBackCount);
            });
    }

    navigateToRightShipInspection() {
        this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.RightShipInspection, { id: this.item.rightShipInspectionId ? this.item.rightShipInspectionId : this.generatedId, source: "vessels" }, { replace: true });
        if (!this.item.rightShipInspectionId || this.item.rightShipInspectionId == 0)
            this.router.history.setState("skipPreviousRoutes", 1);
    }

    isEdit: boolean;
    public async activate(params: any, navigationInstruction: any): Promise<void> {
        const vesselId = UrlHelper.getParameterValueByKey('vesselId', window.location.href)
        if (vesselId) {
            const vesselResponse = await this.manageVesselService.getVessel({
                vesselId: parseInt(vesselId),
                bKey: '',
                imo: ''
            });
            this.vesselDetails.vessel = vesselResponse.vessel;
            this.isSanctioned = vesselResponse.vessel.isSanctioned;
            this.isRestricted = vesselResponse.vessel.isRestricted;
            this.beneficialOwnerIsNullOrUnkown = (!vesselResponse.vessel.beneficialOwnerCompanyId || (vesselResponse.vessel.beneficialOwnerCompany && vesselResponse.vessel.beneficialOwnerCompany.toLowerCase() == "unknown")); 
            this.vesselDetails.vesselIsRestricted = this.isRestricted;
            this.vesselDetails.vesselHasBeneficialOwnerMissing = this.beneficialOwnerIsNullOrUnkown;
            this._isCompanyRestricted = vesselResponse.vessel.isDOCRestricted || vesselResponse.vessel.isBORestricted;
            this.disableButtons = this.disableButtons 
                                || this.isRestricted 
                                || this.beneficialOwnerIsNullOrUnkown
                                || this._isCompanyRestricted;
            
            this.eventAggregator.publish(Messages.InspectedVesselChanged, {isDisabled: this.disableButtons, vesselId: parseInt(vesselId)});
        }
        this.isEdit = params.edit == "true";
        this.declarationTab.isEdit = params.edit == "true";
        this.portAndOperationalDetails.isEdit = this.isEdit;
        this.agentDetailsTab.isEdit = this.isEdit;
        this.vesselDetails.showVesselEF = !this.isEdit && !params.guid && !this.vesselDetails.vessel && !params.vesselId;
        this.inspectionTypeId = Number(params.inspectionTypeId ? params.inspectionTypeId : RightShipInspectionType.RightShipInspection);

        if (this.inspectionTypeId == RightShipInspectionType.CargillSurvey && !this.canCreateCargillInspection) {
            this.router.navigateToRoute(GenesisRouterConstants.RouteNames.StatusCode401);
        }
        else {
            this.router.title = this.inspectionType + " Inspection";
            this.router.updateTitle();

            if (this.vesselDetails.vessel) {
                const response = await this.rightShipInspectionService.getRequiredRightShipInspection(this.vesselDetails.vessel.vesselId, this.inspectionTypeId, false);
                this.vesselHasRequiredRightShipInspection = response.rightShipInspection != null;
                this.hasPendingInspection = response.hasPendingInspection;

                if (this.vesselHasRequiredRightShipInspection) {
                    params.id = response.rightShipInspection.rightShipInspectionId;
                }
            }

            await super.activate(params, navigationInstruction);
        }
    }

    protected getListRoute(): string {
        return null;
    }

    protected getSteps(): StepModel[] {
        return [];
    }

    protected getItem(id: number): Promise<RightShipInspectionModel> {
        return new Promise((resolve, reject) => {
            if (this._params.guid) {
                this.rightShipInspectionService.getRightShipInspectionByGuid(this._params.guid).then(resolve).catch(reject);
            } else if (this.vesselHasRequiredRightShipInspection && this.vesselDetails.vessel) {
                this.rightShipInspectionService.getRequiredRightShipInspection(this.vesselDetails.vessel.vesselId, this.inspectionTypeId, true).then(response => {
                    resolve(response.rightShipInspection);
                }).catch(reject);
            } else {
                this.rightShipInspectionService.getRightShipInspection(id).then(resolve).catch(reject);
            }
        })
    }

    protected getEntityInternal(id: number, resolve: any, reject: any) {
        if ((id && id > 0) || this._params.guid) {
            this.getExistingEntity(id, resolve, reject);
        } else {
            this.isCreateScreen = true;
            const possiblePromiseItem = this.initializeItemForCreate();
            const func = (item) => {
                item.identifier = Guid.generateGuid();
                this.item = item;
                this.clearChanges(() => {
                    this.initializeItemOverride();
                    this.refreshSteps();
                    resolve();
                });
            }
            if (possiblePromiseItem instanceof Promise) {
                possiblePromiseItem.then(x => {
                    func(x);
                }).catch(() => {
                    func(null);
                });
            } else {
                func(possiblePromiseItem);
            }
        }
    }

    @computedFrom(Reflection.getPropertyPath<AddRightShipInspection>(z => z.item),
        Reflection.getPropertyPath<AddRightShipInspection>(z => z.item.rightShipInspectionTypeId))
    get isWet() {
        return this.item && this.item.rightShipInspectionTypeId == RightShipInspectionType.TankerInspection;
    }

    protected getItemId(): number {
        return this.item.rightShipInspectionId;
    }

    protected saveItem(id: number, changes: { [index: string]: UnitOfWorkItem; }): Promise<BaseValidationResponse> {
        return new Promise((resolve, reject) => {

            if (this.vesselDetails.showVesselEF) {
                this.rightShipInspectionService.getRequiredRightShipInspection(this.vesselDetails.vessel.vesselId, this.inspectionTypeId, false).then(response => {
                    this.rightShipInspectionService.saveRightShipInspection({
                        id: response.rightShipInspection ? response.rightShipInspection.rightShipInspectionId : id,
                        changes: changes,
                        isRequest: !this.isEdit,
                        countryId: this.item.countryId,
                        inspectionTypeId: this.item.rightShipInspectionTypeId,
                        attachments: this.declarationTab.attachments,
                        inspectionSourceId: RightShipInspectionSourceEnum.Website,
                        useMobileInspectionWorkflow: true
                    }).then(resolve).catch(reject);
                });
            }
            else {
                this.rightShipInspectionService.saveRightShipInspection({
                    id: id,
                    changes: changes,
                    isRequest: !this.isEdit,
                    countryId: this.item.countryId,
                    inspectionTypeId: this.item.rightShipInspectionTypeId,
                    attachments: this.declarationTab.attachments,
                    inspectionSourceId: RightShipInspectionSourceEnum.Website,
                    useMobileInspectionWorkflow: true
                }).then(resolve).catch(reject);
            }
        });
    }



    protected getUpdateRoute(): string {
        return null;
    }

    protected getEntityType(): EntityTypes {
        return EntityTypes.RightShipInspection;
    }

    protected navigateToVet() {
        this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.RightShipInspection, { id: this.item.rightShipInspectionId, source: "vessels" }, { replace: true })
    }

    public set agreeToTermsAndConditions(value) {
        this.item.agreeToTermsAndConditionsDateTime = value ? new Date() : null;
        this.item.agreeToTermsAndConditions = value;
    }

    @computedFrom("item.agreeToTermsAndConditions")
    public get agreeToTermsAndConditions() {

        if (!this.showTermsAndConditions) return true;

        return this.item.agreeToTermsAndConditions;
    }

    protected initializeItemForCreate(): RightShipInspectionModel | Promise<RightShipInspectionModel> {
        return {
            additionalEmailsToNotify: null,
            agentEmail: null,
            berth: null,
            agentName: null,
            agentOfficeNumber: null,
            agentOfficeNumberWithoutCode: null,
            assignedToUserName: null,
            assignmentComment: null,
            hasVet: false,
            inspectionRequestComments: null,
            previouslyAssignedToUserName: null,
            rightShipInspectionId: 0,
            technicalManagerContactNumber: null,
            technicalManagerContactNumberWithoutCode: null,
            technicalManagerEmail: null,
            technicalManagerName: null,
            technicalManagmentCompany: null,
            vesselId: 0,
            pscInspectionId: null,
            incidentId: null,
            vesselOwnerName: null,
            rightShipInspectionDeficiencies: [],
            invoices: [],
            agreeToSafetyScoreClause: null,
            agreeToTermsAndConditions: null,
            agreeToTermsAndConditionsDateTime: null,
            allDeficienciesReviewed: false,
            assignedDate: null,
            assignedTo: null,
            businessUnitId: null,
            cargoOperationId: null,
            countryId: null,
            currentRightShipInspectionStatusHistoryId: null,
            entityType: EntityTypes.RightShipInspection,
            estimatedArrivalDate: null,
            fullInspectionReportReviewed: null,
            identifier: Guid.generateGuid(),
            inspectingCompanyId: null,
            rightShipInspectionTypeId: null,
            inspectorId: null,
            isVesselOwnerInformedAndAgreed: null,
            antiBriberyAndCorruptionPolicy: null,
            lengthOfTimeAtBerth: null,
            noLetterOfIndemnityWillBeSigned: null,
            bothOwnerAndManagerPromptlyReport: false,
            numberOfDeficiencies: 0,
            overallAssessmentId: null,
            actualDateOfInspection: null,
            correspondenceEmail: null,
            cargillInspectionDetails: this.isCargill ? {
                shipSuitable: null,
                accommodationProbability: null,
                accommodationSeverity: null,
                cargoAndBallastSystemsProbability: null,
                cargoAndBallastSystemsSeverity: null,
                certificationAndDocumentationProbability: null,
                certificationAndDocumentationSeverity: null,
                crewManagementProbability: null,
                crewManagementSeverity: null,
                hullAndDeckItemsProbability: null,
                hullAndDeckItemsSeverity: null,
                machinerySpacesProbability: null,
                machinerySpacesSeverity: null,
                navigationProbability: null,
                navigationSeverity: null,
                pollutionManagementProbability: null,
                pollutionManagementSeverity: null,
                safetyManagementProbability: null,
                safetyManagementSeverity: null
            } : null,
            wetInspectionDetails: this.isWet ? {
                legacyWetInspectionVesselOperationId: null,
                legacySpmMooringSuitable: null,
                legacyStsSuitable: null,
                legacyWetInspectionVrsSuitabilityId: null,
                legacyHullTypeId: this.vesselDetails.vessel ? this.vesselDetails.vessel.hullTypeId : null,
                legacyTradingAreaId: null,
                wetInspectionTypeId: null
            } : null,
            portId: null,
            previouslyAssignedTo: null,
            useMobileInspectionWorkflow: false,
            inspectorContactNumber: null,
            inspectorEmail: null,
            reasonForInspectionId: null,
            requestedDateOfInspection: null,
            validityExpiryDate: null,
            requiresRightshipInspectionComments: null,
            rightShipInspectionVesselTypeId: null,
            isSelfUnloadingVessel: null,
            isUsingLngFuel: null,
            isEquippedWithGantryCranes: null,
            hasIceClassNotation: null,
            isGearlessVessel: null,
            isRoRoShip: null,
            isTimberCarrier: null,
            isCarryingGrainCargoAndHasBeenFumigatedInThePast12Months: null,
            isHybrid: false,
            cargoOperationComments: null,
            captainName: null,
            captainEmail: null,
            isVesselInvolvedInSts: null,
            ackWatchedMessageCentreVideo: false
        };
    }

    @computedFrom(Reflection.getPropertyPath<AddRightShipInspection>(z => z.isDry),
        Reflection.getPropertyPath<AddRightShipInspection>(z => z.isEdit),
        Reflection.getPropertyPath<AddRightShipInspection>(z => z.item),
        Reflection.getPropertyPath<AddRightShipInspection>(z => z.hasPendingInspection),
        Reflection.getPropertyPath<AddRightShipInspection>(z => z.item.currentRightShipInspectionStatusHistory))
    public get linkClosed() {
        if (!this.isDry) {
            return false;
        }

        const statues = [
            RightShipInspectionStatusEnum.InspectionRequired
        ];
        return !this.isEdit && ((
            this.item && this.item.currentRightShipInspectionStatusHistory && statues.indexOf(this.item.currentRightShipInspectionStatusHistory.rightShipInspectionStatusId) == -1) ||
            this.hasPendingInspection);
    }

    private setUseMobileInspectionWorkflow() {
        if (this.inspectionTypeId == RightShipInspectionType.RightShipInspection
            && (!this.item.rightShipInspectionId
                || (this.item.entityStatusId == RightShipInspectionStatusEnum.InspectionRequired)
            )
        ) {
            this.item.useMobileInspectionWorkflow = true;
        }
    }

    protected initializeItemOverride() {
        this.shipManagerDetailsTab.additionalEmailsToNotify = this.shipManagerDetailsTab.getListOfEmails(this.item.additionalEmailsToNotify);
        this.item.rightShipInspectionTypeId = this.inspectionTypeId;

        this.setUseMobileInspectionWorkflow();

        if (this.vesselDetails.vessel) {
            this.item.vesselId = this.vesselDetails.vessel.vesselId;
            if (!this.item.vesselOwnerName)
                this.item.vesselOwnerName = this.vesselDetails.vessel.commericalOwnerCompany;
        } else {
            this.item.vesselId = this._params.vesselId ? this._params.vesselId : null;
            if (this.item.vesselId)
                this.loadVessel();
        }

        this.invoiceTransmissionDetailsTab.initModels();
    }

    protected initializeItemOverrideForUpdate() {
        this.item.rightShipInspectionTypeId = this.inspectionTypeId;
        this.setUseMobileInspectionWorkflow();

        if (!this.item.vesselOwnerName && this.vesselDetails.vessel) {
            this.item.vesselOwnerName = this.vesselDetails.vessel.commericalOwnerCompany;
        }

        if (this.showTermsAndConditions) {
            this.item.inspectionRequestComments = null;
            this.item.additionalEmailsToNotify = null;
        }
        this.shipManagerDetailsTab.additionalEmailsToNotify = this.shipManagerDetailsTab.getListOfEmails(this.item.additionalEmailsToNotify);

        if (!this.vesselDetails.vessel && this.item.vesselId) {
            this.loadVessel();
        }

        this.invoiceTransmissionDetailsTab.initModels();

        //splitting country code from phone number
        if (this.item && this.item.technicalManagerContactNumber && this.item.technicalManagerContactNumber.indexOf(" ") > -1) {
            this.shipManagerDetailsTab.technicalManagerCountryCode = this.item.technicalManagerContactNumber.split(" ")[0];
            this.item.technicalManagerContactNumberWithoutCode = this.item.technicalManagerContactNumber.replace(this.shipManagerDetailsTab.technicalManagerCountryCode + " ", "");
        }

        if (this.item && this.item.agentOfficeNumber && this.item.agentOfficeNumber.indexOf(" ") > -1) {
            this.agentDetailsTab.agentOfficeCountryCode = this.item.agentOfficeNumber.split(" ")[0];
            this.item.agentOfficeNumberWithoutCode = this.item.agentOfficeNumber.replace(this.agentDetailsTab.agentOfficeCountryCode + " ", "");
        }

        if (this.item && this.item.invoices && this.item.invoices[0] && this.item.invoices[0].phoneNumber && this.item.invoices[0].phoneNumber.indexOf(" ") > 0) {
            this.invoiceTransmissionDetailsTab.phoneCountryCode = this.item.invoices[0].phoneNumber.split(" ")[0];
            this.item.invoices[0].phoneNumberWithoutCode = this.item.invoices[0].phoneNumber.replace(this.invoiceTransmissionDetailsTab.phoneCountryCode + " ", "");
        }
    }

    loadVessel() {
        if (this.isAuthenticated) {
            this.manageVesselService.getVessel({
                vesselId: this.item.vesselId,
                imo: null,
                bKey: null
            }).then(x => {
                this.vesselDetails.vessel = x.vessel;
                this.isSanctioned = x.vessel.isSanctioned;
                this.isRestricted = x.vessel.isRestricted;
                this.beneficialOwnerIsNullOrUnkown = (!x.vessel.beneficialOwnerCompanyId || (x.vessel.beneficialOwnerCompany && x.vessel.beneficialOwnerCompany.toLowerCase() == "unknown")); 
                this.vesselDetails.vesselIsRestricted = this.isRestricted;
                this.vesselDetails.vesselHasBeneficialOwnerMissing = this.beneficialOwnerIsNullOrUnkown;
                this.disableButtons = this.disableButtons 
                                || this.isRestricted
                                || this.beneficialOwnerIsNullOrUnkown;

                this.eventAggregator.publish(Messages.InspectedVesselChanged, {isDisabled: this.disableButtons, vesselId: this.item.vesselId});

                if (this.item.rightShipInspectionId)
                    this.initializeItemOverride();
                else
                    this.initializeItemOverrideForUpdate();
            });
        }
        else {
            this.manageVesselService.getVesselAnonymously({
                vesselId: this.item.vesselId,
                imo: null,
                bKey: null
            }).then(x => {
                this.vesselDetails.vessel = x.vessel;
                if (this.item.rightShipInspectionId)
                    this.initializeItemOverride();
                else
                    this.initializeItemOverrideForUpdate();
            });
        }
    }

    wetInspectionDetailsAnswerChanged(property: string, isChecked: boolean, newValue?: boolean) {
        if (this.item.wetInspectionDetails && this.item.wetInspectionDetails[0] && isChecked) {
            this.item.wetInspectionDetails[0][property] = newValue;
        }
    }

    public beforeSave(skipValidation: boolean, resolve: (isValid: boolean) => void) {
        //trim emails
        this.cleanEmails();

        this.setValidator();

        this.validator.validate().then(x => {
            this.shipManagerDetailsTab.setAdditionalEmailsToNotifyString();
            this.invoiceTransmissionDetailsTab.setInvoiceEmailsString();

            if (x.valid) {
                if (this.shipManagerDetailsTab.technicalManagerCountryCode) {
                    while (this.shipManagerDetailsTab.technicalManagerCountryCode.indexOf(" ") > -1) {
                        this.shipManagerDetailsTab.technicalManagerCountryCode = this.shipManagerDetailsTab.technicalManagerCountryCode.replace(" ", "");
                    }
                    this.item.technicalManagerContactNumber = this.shipManagerDetailsTab.technicalManagerCountryCode + " " + this.item.technicalManagerContactNumberWithoutCode;
                }
                else {  
                    this.item.technicalManagerContactNumber = this.item.technicalManagerContactNumberWithoutCode;
                }

                if (this.agentDetailsTab.agentOfficeCountryCode) {
                    while (this.agentDetailsTab.agentOfficeCountryCode.indexOf(" ") > -1) {
                        this.agentDetailsTab.agentOfficeCountryCode = this.agentDetailsTab.agentOfficeCountryCode.replace(" ", "");
                    }
                    this.item.agentOfficeNumber = this.agentDetailsTab.agentOfficeCountryCode + " " + this.item.agentOfficeNumberWithoutCode;
                }
                else {
                    this.item.agentOfficeNumber = this.item.agentOfficeNumberWithoutCode;
                }

                if (this.item.invoices[0] && this.invoiceTransmissionDetailsTab.phoneCountryCode) {
                    while (this.invoiceTransmissionDetailsTab.phoneCountryCode.indexOf(" ") > -1) {
                        this.invoiceTransmissionDetailsTab.phoneCountryCode = this.invoiceTransmissionDetailsTab.phoneCountryCode.replace(" ", "");
                    }
                    this.item.invoices[0].phoneNumber = this.invoiceTransmissionDetailsTab.phoneCountryCode + " " + this.item.invoices[0].phoneNumberWithoutCode;
                }
                else if (this.item.invoices[0]){
                    this.item.invoices[0].phoneNumber = this.item.invoices[0].phoneNumberWithoutCode;
                }
            }
            resolve(x.valid);
        });
    }

    private cleanEmails() {
        if (this.item.technicalManagerEmail)
            this.item.technicalManagerEmail = this.item.technicalManagerEmail.trim();
        if (this.item.agentEmail)
            this.item.agentEmail = this.item.agentEmail.trim();
        if (this.item.correspondenceEmail)
            this.item.correspondenceEmail = this.item.correspondenceEmail.trim();
        if (this.item.inspectorEmail)
            this.item.inspectorEmail = this.item.inspectorEmail.trim();
        if (this.shipManagerDetailsTab.additionalEmailsToNotify)
            this.shipManagerDetailsTab.additionalEmailsToNotify.forEach(x => {
                if (x.email)
                    x.email = x.email.trim();
            });
        if (this.invoiceTransmissionDetailsTab.invoiceEmails)
            this.invoiceTransmissionDetailsTab.invoiceEmails.forEach(x => {
                if (x.email)
                    x.email = x.email.trim();
            });
    }

    @computedFrom(Reflection.getPropertyPath<AddRightShipInspection>(z => z._tabs),
        Reflection.getPropertyPath<AddRightShipInspection>(z => z._tabs.length),
        Reflection.getPropertyPath<AddRightShipInspection>(z => z.currentTabIndex))
    get isLastTab() {
        const visibleTabs = this._tabs.filter(x => x.isVisible());
        const last = Enumerable.from(visibleTabs).lastOrDefault();
        return this.currentTabIndex == visibleTabs.indexOf(last);
    }

    protected getPropertiesToSkip() {
        return ["currentRightShipInspectionStatusHistory"];
    }

    public getViewModel(vm: any, path: string) {
        if (vm && path) {
            require(path + '.ts');
            require(path + '.html');
            return vm;
        }
    }
}
